// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scorbunny: PokeData = {
  "id": 813,
  "name": "scorbunny",
  "height": 3,
  "weight": 45,
  "base_experience": 62,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "double-edge",
    "growl",
    "ember",
    "counter",
    "agility",
    "quick-attack",
    "bounce",
    "flame-charge"
  ],
  "moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "growl",
    "ember",
    "quick-attack",
    "morning-sun",
    "flare-blitz",
    "flamethrower",
    "eruption",
    "fire-spin",
    "blaze-kick",
    "fire-punch"
  ],
  "evolution_chain": {
    "id": 431,
    "item": null,
    "species": [
      {
        "name": "scorbunny",
        "order": 813,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "raboot",
        "order": 814,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 813,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "cinderace",
        "order": 815,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 814,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 69,
    "ability_power": 71
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
